import { useCart } from "../context/CartContext";
import SEO from "../components/SEO";
import seoPages from "../data/seoPages.json";
import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { 
  XCircle, 
  RefreshCw, 
  MessageCircle,
  Send,
  CreditCard
} from "lucide-react";
import { Button } from "../components/ui/button";

export const PaymentFailedPage = () => {
  const { setShowCart } = useCart();
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoPages.paymentFailed} />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-[#F1EDE4] to-[#E6E0D3]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-500/20 rounded-full mb-6">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Оплата не прошла
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            К сожалению, платёж не был завершён. Если банк показывает списание, проверьте статус платежа или обратитесь в поддержку.
          </p>
        </div>
      </section>

      {/* Actions Section */}
      <section className="py-16 -mt-8">
        <div className="max-w-2xl mx-auto px-6">
          {/* Retry Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-teal-500/10 rounded-xl flex items-center justify-center">
                  <RefreshCw className="w-6 h-6 text-teal-600" />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Попробовать снова
                </h3>
                <p className="text-gray-600 mb-4">
                  Вернитесь в корзину и повторите попытку оплаты. Убедитесь, что на карте достаточно средств.
                </p>
                <Button onClick={() => setShowCart(true)} className="bg-teal-600 hover:bg-teal-500 text-white font-semibold px-6 py-3">
                    <CreditCard className="w-5 h-5 mr-2" />
                    Вернуться в корзину
                  </Button>
              </div>
            </div>
          </div>

          {/* Possible Reasons */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Возможные причины:
            </h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start gap-3">
                <span className="text-teal-500 mt-1">•</span>
                <span>Недостаточно средств на карте</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-teal-500 mt-1">•</span>
                <span>Карта заблокирована или истёк срок действия</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-teal-500 mt-1">•</span>
                <span>Банк отклонил транзакцию (попробуйте другую карту)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-teal-500 mt-1">•</span>
                <span>Превышен лимит на онлайн-платежи</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-teal-500 mt-1">•</span>
                <span>Проблемы с интернет-соединением</span>
              </li>
            </ul>
          </div>

          {/* Support Card */}
          <div className="bg-[#F1EDE4] rounded-2xl p-8 text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-teal-500/20 rounded-full mb-4">
              <MessageCircle className="w-7 h-7 text-teal-400" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Нужна помощь?
            </h3>
            <p className="text-gray-400 mb-5">
              Если проблема повторяется, напишите нам — мы поможем разобраться.
            </p>
            <a
              href="https://t.me/DmitriiFokeev"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-[#0088cc] hover:bg-[#0077b5] text-white font-semibold px-6 py-3">
                <Send className="w-5 h-5 mr-2" />
                Написать в Telegram
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentFailedPage;
